import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ManageRequestRoutingModule } from './manage-request-routing.module';
import { ManageRequestComponent } from './manage-request.component';
import { CoreModule } from '../../core/core.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { TableModule } from 'primeng/table';

@NgModule({
  imports: [
    CommonModule,
    CoreModule,
    DropdownModule,
    ManageRequestRoutingModule,
    NgbModule,
    FormsModule,
    TableModule,
  ],
  declarations: [ManageRequestComponent]
})
export class ManageRequestModule { }



// WEBPACK FOOTER //
// /opt/app/src/app/features/manage-request/manage-request.module.ts